import { registerSW } from 'virtual:pwa-register';

// Module-level storage for pending SW update function
// This avoids race conditions with event listeners.
// `registerSW` returns a `(reloadPage?: boolean) => Promise<void>` —
// keep the Promise in the type so callers can await it if they want.
type SwUpdateFn = (reloadPage?: boolean) => Promise<void>;
let pendingUpdateFn: SwUpdateFn | null = null;

/**
 * Get the pending SW update function if one is available.
 * Returns null if no update is pending.
 */
export function getPendingSwUpdate(): SwUpdateFn | null {
  return pendingUpdateFn;
}

/**
 * Clear the pending update (call after applying it).
 */
export function clearPendingSwUpdate(): void {
  pendingUpdateFn = null;
}

if (import.meta.env.PROD) {
  const updateSW = registerSW({
    onNeedRefresh() {
      console.log('New content is available. Will update on next navigation.');
      pendingUpdateFn = updateSW;
    },
    onOfflineReady() {
      console.log('App is offline ready.');
    },
    onRegisteredSW() {
      console.log('FTL service worker registered.');
    },
    onRegisterError(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}
